// import React, { useState, useEffect } from 'react';
import "../css/CuPopup.css";

import { useEffect } from "react";
// const CuPopup = ({ trigger, content, position }) => {
//   const [isOpen, setIsOpen] = useState(false);

//   const togglePopup = () => {
//     setIsOpen(!isOpen);
//   };

//   useEffect(() => {
//     const handleOutsideClick = (event) => {
//       if (isOpen && !event.target.closest('.popup-container')) {
//         setIsOpen(false);
//       }
//     };

//     document.addEventListener('mousedown', handleOutsideClick);

//     return () => {
//       document.removeEventListener('mousedown', handleOutsideClick);
//     };
//   }, [isOpen]);

//   const popupPositionClass =
//     position === 'right' ? 'popup-right' : 'popup-left';

//   return (
//     <div className={`popup-container ${popupPositionClass}`}>
//       <div className="popup-trigger" onClick={togglePopup}>
//         {trigger}
//       </div>
//       {isOpen && (
//         <div className="popup-content">
//           <div className={`popup-arrow ${popupPositionClass}`}></div>
//           <div className="popup-close" onClick={togglePopup}>
//             &times;
//           </div>
//           {content}
//         </div>
//       )}
//     </div>
//   );
// };

// export default CuPopup;

import React, { useState, useRef } from "react";
import PropTypes from "prop-types";

const CuPopup = ({
  trigger,
  position,
  animation,
  triggerEvent,
  customPosition,
  children,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const popupRef = useRef(null);

  const handleTrigger = () => {
    if (triggerEvent === "click") {
      setIsVisible(!isVisible);
    }
  };

  const handleMouseEnter = () => {
    if (triggerEvent === "hover") {
      setIsVisible(true);
    }
  };

  const handleMouseLeave = () => {
    if (triggerEvent === "hover") {
      setIsVisible(false);
    }
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsVisible(!isVisible);
      }
    };

    if (isVisible) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.body.classList.remove("modal-open");

      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isVisible]);

  const getPositionStyles = () => {
    switch (position) {
      case "top":
        return { top: "0", left: "60px", transform: "translateX(-50%)" };
      case "bottom":
        return { bottom: "0", left: "60px", transform: "translateX(-50%)" };
      case "left":
        return { top: "50%", left: "0", transform: "translateY(-50%)" };
      case "right":
        return { top: "50%", right: "0", transform: "translateY(-50%)" };
      case "custom":
        return customPosition; // Use custom position directly
      default:
        return { top: "0", left: "60px", transform: "translateX(-50%)" };
    }
  };

  const getAnimationClass = () => {
    switch (animation) {
      case "fade":
        return "fade-animation";
      case "scale":
        return "scale-animation";
      case "slide":
        return "slide-animation";
      default:
        return "";
    }
  };

  return (
    <div className="popup-container">
      <div
        ref={popupRef}
        className={`popup ${isVisible ? "show" : "hide"
          } ${getAnimationClass()}`}
        style={{ ...getPositionStyles() }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="cu-popup-content" style={{ border: "none", width: "fit-content" }}>
          {/* <span className="close-btn" onClick={handleClose}>
            ×
          </span> */}
          {children}
        </div>
      </div>
      {React.cloneElement(trigger, {
        onClick: handleTrigger,
        onMouseEnter: triggerEvent === "hover" ? handleMouseEnter : undefined,
        onMouseLeave: triggerEvent === "hover" ? handleMouseLeave : undefined,
      })}
    </div>
  );
};

CuPopup.propTypes = {
  trigger: PropTypes.element.isRequired,
  position: PropTypes.oneOf(["top", "bottom", "left", "right", "custom"]),
  animation: PropTypes.oneOf(["fade", "scale", "slide"]),
  triggerEvent: PropTypes.oneOf(["click", "hover"]),
  children: PropTypes.node,
};

CuPopup.defaultProps = {
  position: "top",
  animation: "fade",
  triggerEvent: "click",
};

export default CuPopup;
